import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { GetStaticProps } from 'next'
import clsx from 'clsx'

import Seo from '@/molecules/SEO/SEO'
import OrderCarousel from '@/molecules/OrderCarousel/OrderCarousel'
import OrderFormRenderer from '@/templates/OrderingFlow/OrderFormRenderer'
import { contentData, CustomFormSource } from '@/templates/OrderingFlow/fields'
import { TEN_MINS_REVALIDATION } from '@/utils/constants/revalidation'

/* assets */
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo.svg'

/* styling */
import styles from '@/styles/order/order.module.css'

export const SESSION_STORAGE_FORM_TYPE = `inbound-form-type`

const customFormSources: CustomFormSource[] = ['newsletter', 'cml']

function OrderPage() {
  const router = useRouter()

  const [formSource, setFormSource] = useState<CustomFormSource | null>(null)

  // setting formSource from query param or session storage
  useEffect(() => {
    const _formTypeQueryParam = router.query.formType?.toString()

    // set formType from query param to session-storage
    if (
      _formTypeQueryParam &&
      customFormSources.includes(_formTypeQueryParam as CustomFormSource)
    ) {
      setFormSource(_formTypeQueryParam as CustomFormSource)
      sessionStorage.setItem(SESSION_STORAGE_FORM_TYPE, _formTypeQueryParam)
      return
    }
    // check if formType is present in session storage
    const _formTypeSessionStorage = sessionStorage.getItem(
      SESSION_STORAGE_FORM_TYPE
    )
    if (
      !formSource &&
      _formTypeSessionStorage &&
      customFormSources.includes(_formTypeSessionStorage as CustomFormSource)
    ) {
      setFormSource(_formTypeSessionStorage as CustomFormSource)
      sessionStorage.setItem(SESSION_STORAGE_FORM_TYPE, _formTypeSessionStorage)
      return
    }
  }, [formSource, router.query.formType])

  const showSidebar = formSource
    ? contentData[formSource]?.showSidebar ?? true
    : true

  return (
    <main
      className={clsx(styles.container, !showSidebar && styles.hiddenSidebar)}
    >
      <Seo title="Book a demo | Pepper Content" canonical="/book-a-demo/" />
      <div className={styles.contentArea}>
        <header className="bg-white | flex items-center | sticky top-0 z-10 | px-5 lg:px-6">
          <PepperLogo className="h-7 lg:h-8" />
        </header>

        <div className="max-w-[528px] | mx-auto pt-8 pb-16 md:pt-12 md:pb-20 px-5">
          <OrderFormRenderer formSource={formSource} />
        </div>
      </div>

      <aside
        className={clsx(
          styles.carouselContainer,
          'sticky top-0 | max-h-screen | pt-12 pb-16 px-5'
        )}
      >
        <OrderCarousel />
      </aside>
    </main>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default OrderPage
